





















































































import { Component, Mixins } from "vue-property-decorator";
import CRUDMixins from "@/mixins/CRUDMixins";
import QuestionMixins from "@/mixins/QuestionMixins";
import { mapState } from "vuex";
import _ from "lodash";
import QQuestionnaireResultLayout from "@/components/Questionnaire/QQuestionnaireResultLayout.vue";

@Component({
  components: {
    QQuestionnaireResultLayout
  },
  computed: {
    ...mapState("CandidateProfile", {
      questionGroups: "questionGroups",
      isUsingForScreens: "isUsingForScreens"
    }),
    ...mapState({
      loading: "loading"
    })
  }
})
export default class CandidateProfileRead extends Mixins(
  CRUDMixins,
  QuestionMixins
) {
  questionGroups!: [];
  isUsingForScreens!: boolean;

  title = "Your Quescreen Profile";
  description = `We collect general information about you to create your Quescreen Profile.
    <br />
    It's important to provide accurate and up-to-date
    information to assist Quescreen provide you with relevant
    question groups, and ultimately assess your human health
    risk against a defined job role.`;
  isMounted = false;
  showWarning = false;
  showErrorDialog = false;

  get questionGroupResult() {
    return this.questionGroups.map(
      this.$store.getters["Questionnaire/mapQuestionGroup"]
    );
  }

  get isEmptyCandidateProfile() {
    return _.isEmpty(this.questionGroups);
  }

  async beforeMount() {
    await this.$store
      .dispatch("CandidateProfile/fetchForRead")
      .then(() => {
        if (this.isEmptyCandidateProfile) {
          this.title = "Let’s get started with your Personal Profile";
          this.description =
            "Please provide personal and basic health information prior to completing the Quescreen questionnaire.";
          this.$emit("update-actions", []);
        }
        this.isMounted = true;
      })
      .catch(({ response }) => {
        console.error(response);
        this.showErrorDialog = true;
      });
  }

  read() {
    if (this.isUsingForScreens) {
      this.showWarning = true;
    } else {
      this.toUpdate();
    }
  }

  toUpdate() {
    this.$router.push({
      name: "candidate-profile-update"
    });
  }
}
